/**
 * Preferencia de idioma del visitante, guardada en `localStorage`.
 *
 * Módulo diminuto y sin dependencias de React: solo lee/escribe el idioma que
 * el usuario eligió en el selector. Todo acceso al almacenamiento va en
 * try/catch porque `localStorage` puede no existir o lanzar (modo privado,
 * almacenamiento bloqueado); en ese caso se degrada en silencio al
 * comportamiento sin preferencia.
 */

import { SUPPORTED_LANGUAGES } from './languages';

/** Clave de `localStorage` donde se guarda el idioma elegido. */
export const LANGUAGE_STORAGE_KEY = 'intercasa.language';

/**
 * Lee el idioma guardado.
 * @returns {string|null} Idioma soportado, o `null` si no hay, no es válido o el almacenamiento falla.
 */
export const getSavedLanguage = () => {
  try {
    const value = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return SUPPORTED_LANGUAGES.includes(value) ? value : null;
  } catch {
    return null;
  }
};

/**
 * Guarda el idioma elegido (también `es`, como elección explícita).
 * Ignora idiomas no soportados y errores de almacenamiento.
 * @param {string} lang - Código de idioma soportado.
 * @returns {void}
 */
export const saveLanguage = (lang) => {
  if (!SUPPORTED_LANGUAGES.includes(lang)) return;
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // Almacenamiento no disponible: se sigue sin recordar la elección.
  }
};
